import { render, staticRenderFns } from "./AddCanned.vue?vue&type=template&id=bdbe548e&scoped=true&"
import script from "./AddCanned.vue?vue&type=script&lang=js&"
export * from "./AddCanned.vue?vue&type=script&lang=js&"
import style0 from "./AddCanned.vue?vue&type=style&index=0&id=bdbe548e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbe548e",
  null
  
)

export default component.exports